import React from 'react';
import Pages from './Pages';

class Attributions extends Pages {
  componentDidMount() {
    window.scrollTo(0, 0)
}
  leftmenu = () => {
    return (

      <div className='leftmenu'>
        <div>Attributions</div>
        <br />
        <button onClick={() => this.scroll(this.tenthRef)} className={'section'}> Team Members </button>

        <button onClick={() => this.scroll(this.firstRef)} className={'section'}> Principal Investigators </button>


        <button onClick={() => this.scroll(this.secondRef)} className={'section'}> Lab Support  </button>


        <button onClick={() => this.scroll(this.thirdRef)} className={'section'}>  Fundraising support</button>

        <button onClick={() => this.scroll(this.fourthRef)} className={'section'}>  Human Practice Support</button>
        <button onClick={() => this.scroll(this.refRef)} className={'section'}>  References</button>
      </div>
    )
  }
  righttext = () => {
    return (
      <div className='righttext'>
        <h2 ref={this.tenthRef}>Team Members</h2><br/>
        <div>
          <b>Team leaders:</b><br/>
          &emsp; - Christian Nelson Tejedor Vicera<br/>
          &emsp; - Rita Lim<br/><br/>
          <b>Wet Lab Members:</b><br/>
          &emsp; - Eugenia Fong<br/>
          &emsp; - Louis Yu<br/>
          &emsp; - Sneha Balasubramanian<br/>
          &emsp; - Tanvi Falodiya<br/><br/>
          <b>Dry Lab Members:</b><br/>
          &emsp; - Jegadishwar Ananda Natarajan<br/>
          &emsp; - Angel Ng<br/>
          &emsp; - Clara Pun<br/>
          &emsp; - Sathya Balaji<br/><br/>
          <b>Science Communication Members:</b><br/>
          &emsp; - Fei Fei Long<br/>
          &emsp; - Kirndeep Kaur<br/>
          &emsp; - Sarah Khan<br/>
          &emsp; - Kazi Sunanas Utsha<br/>
          &emsp; - Vismaya Pillai<br/><br/>
          <b>Advisors:</b><br/>
          &emsp; - Kenneth Ng<br/>
          &emsp; - Kailee Poon<br/>
          &emsp; - Sabrina Lerskiatiphanich<br/>
          &emsp; - Angela Fan<br/>
          &emsp; - Jo Yi Chow<br/>
          &emsp; - Isabella Kroon<br/>
          &emsp; - Timothy Ng<br/>
          &emsp; - Sum Lau<br/>
          &emsp; - Shi Diwen<br/>

        </div><br/>

        <h2 ref={this.firstRef}>Principal Investigators</h2>
        <p>
          <br />
          <b>Dr. Amy Tan</b> for her continuous guidance and unwavering faith through our designing and experimenting phases, for offering up her precious lab space for our final experimental stages, for brainstorming with us during the project designing stage. Without her invaluable advice our project would not be as streamlined as it is today. Furthermore, we would like to take this opportunity to specially thank her for being a guest speaker at the iGEM Manchester x iGEM Thessaly iGEM Policy Symposium despite timezone constraints.
          <br /> <br />
          <b> Dr. Juan Diego Gaitán-Espitia</b> for being so accommodating and patient with our ever-expanding project ideas and lab space, for his assistance in negotiating with relevant persons-in-charge in order to provide us with a laboratory space to conduct our experiments and helping us secure access to some essential central facilities and equipment.
          <br /> <br />
          <b>Dr. Edmund Tse</b> for providing us with access to his lab that enabled us to complete the complex final steps of the project, for his advice on the final stages that helped us prioritise our work and get work done in the most efficient way possible
        </p>
        <br /><br />
        <h2 ref={this.secondRef}>Lab Support</h2>
        <p>
          <br />
          <b>Ms. Helen Leung</b> for her patience as we troubled her at least a dozen times a day for lab consumables, equipment and reagents, for navigating and negotiating laboratory and central facilities access on our behalf/with the School Administration. We especially thank her for her kindness in teaching us the nuanced basics of running a research laboratory.
          <br /> <br />
          <b>Ms. Lily Ng</b> for being so accommodating and considerate in providing us with a lab space to carry out our experiments during the course of the summer and kindly extending our access to central facilities thereafter.
          <br /> <br />
          <b>Ms. Apple Chu</b> for her invaluable assistance in providing us with the backbone, pCAMBIA1301, <i>Agrobacterium tumefaciens</i> GV3101 and other reagents involved in the growth and engineering of the <i>Agrobacterium</i>.
          <br /> <br />
          <b>Mr. Zhenzhen Li</b> for showing us the ropes of microalgal culturing.
          <br /> <br />
          <b>HKUST</b> for generously providing us with our principal microalgal chassis, <i>Chlorella vulgaris var. autotrophica</i> and for kick starting our microalgal culturing process by sparing us some of their F/2 medium materials.
          <br /> <br />
          <b>Dr. Robin Barten and the Bioprocess Engineering group of Wageningen University & Research</b> for their prompt assistance in providing us with our second microalgal chassis,<i> Picochlorum sp.</i> BPE23.
          <br /> <br />
          <b>Dr. Lukas Dahlin, Dr. Michael Guarnieri and NREL </b> for graciously providing us with the fascinating new microalgal species, Picochlorum renovo, and for providing us with valuable advice on the revival and maintenance of the microalgal cultures.
          <br /> <br />
          <b>Winnie Tam</b> from the Tse Laboratory for their assistance in sharing their working pipelines and guiding us through product purification.
          <br /> <br />
          <b>Professor Kevin Tsia</b> for providing us with the new Wet Laboratory space at Innovation Wing (Innowing) 1 at the start of the new offline semester, for guiding us through every step of the way during the application process which proved pivotal in securing access to the same and for his endorsement of our team which was critical to our funding processes. We would also like to express our gratitude for his assistance in connecting us with some of his students who helped us conduct the Synthetic Biology Workshop.
          <br /><br />
          <b>Professor Chun Kit Chui </b> for granting us access to Tam Wing Fan Innovation Wing (InnoWing)
          <br /><br />
          <b> Ms. Joyce Fung, Mr. Gary Leung</b> and <b>Tam Wing Fan Innovation Wing (InnoWing) </b>for kindly providing us with a new lab space at the start of a hectic new semester and bearing with our many mistakes while adjusting to the lab usage guidelines
          <br /><br />
          <b>Charis Chan</b> for granting us access to the equipment at central facilities in the School during  the final stages of our experimentation.
          <br /><br />
          <b>Integrated DNA Technologies (IDT)</b> for providing us with free gene fragments and oligos
          <br /><br />
          <b>Snapgene</b> for providing our team members with free licences that were critical in the designing of our parts
          <br /><br />
          <b>Abcam</b> for providing us with student discounts during the vital purchase of our vector pCAMBIA1301
        </p>
        <br /><br />
        <h2 ref={this.thirdRef}>Fundraising support</h2>
        <p>
          <br />
          <b>Ms. Yan Tang</b> and <b>Ms. Susan</b> for their assistance in securing the Faculty of Science Sponsorship to cover member applications to the iGEM competition and Grand Jamboree for members from the Faculty of Science.
          <br /><br />
          <b>Mr. Eric</b> and <b>Ms. Rachel Liu</b> for their guidance regarding our application to the Tam Wing Fan Innovation Fund and Philomathia Foundation Innovation Fund
        </p>
        <br /><br />
        <h2 ref={this.fourthRef}>Human Practice Support</h2>
        <p>
          <br />
          <b>Dr. Clive Lo</b> for sharing his knowledge and experience of working with antimicrobial resistance with us, for critiquing our project design and helping us re-evaluate aspects of the project to enhance its practical application. Further, we would like to thank him for his generosity in providing us with the relevant agrobacterium and bacterial strains needed for our experiments.
          <br /><br />
          <b>Mr. Alex Wang, Mr. Eshan and Mr. William</b> at Geb Impact Technology Co. Ltd. for sharing their expertise in microalgal cultivation, for kindly reviewing our project design and raising challenging and probing questions that made us consider every aspect of our project with a more critical eye.
          <br /><br />
          <b>Dr. Joshua Ho</b> and his laboratory for their guidance and critical support during the development and execution of the HKUMed x HKUiGEM Bioinformatics Workshop for Secondary School Students. We would particularly like to express our gratitude to him for also being a speaker at the same event and his assistance in securing funding for the team from the School of Biomedical Sciences.
          <br /><br />
          <b>Dr. Jason Wong</b> for his kind assistance during the organization of the HKUMed x HKUiGEM Bioinformatics Workshop for Secondary School Students.
          <br /><br />
          <b>Mr. Hoki Chan and Ms. Christina Chan</b> for helping us book the venue at the Li Ka Shing Faculty of Medicine Laboratory Block for the Bioinformatics Worksop, for providing us with the required equipment for the experiments to be conducted during the same and for meeting the government Covid-19 regulations for group events.
          <br /><br />
          <b>Tam Wing Fan Innovation Wing (InnoWing)</b> for providing us with a venue to host our Synthetic Biology Workshop and assisting us in the execution of the event.
          <br /><br />
          <b>Hong Kong University of Science and Technology (HKUST) iGEM Team 2022</b> for inviting us to the HKUST iGEM 2022 Symposium
          <br /><br />
          <b>iGEM Manchester, iGEM Thessaly, iGEM Bath</b> for co-hosting the iGEM Policy Symposium
          <br /><br />
          <b>ASU iGEM and UBC iGEM</b> for inviting us to the Phototroph Community
          <br /><br />
          <b>Sonia Wong</b> at Smart Farming HK for our accepting our interview and for providing us with insights on the operation of fish farms in Hong Kong.  
          <br /><br />
          <b>Dr. Peter Kar-him LUK</b> from Agriculture, Fisheries and Conservation Department Hong Kong for providing our team with information on the maintenance of health marine systems and relevant regulation in Hong Kong
          <br /><br />
          <b>Strangers</b> at Goldfish street for facilitating our street interview on maintenance of the health of fish aquariums in Hong Kong
          <br /><br />
          <b>Astreas</b> for inviting us to showcase images of our queer and LGBTQ+ members at Paradigms: an Exhibition-Showcase surrounding Queer Art.

        </p>
      </div>


    )
  }

  render() {
    return (
      <>
      {/* {this.state.isLoading ? <div className='load-container'><BarLoader color={'silver'} size={150} loading={this.state.isLoading} cssOverride={CSSRef} /></div> : null}s */}
      
        <h1 className='des'>Attributions</h1>
        <div className='pageholder'>
        

          {this.leftmenu()}
          {this.righttext()}
        </div>
      </>
    )
  }
}


export default Attributions;
